/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignStatusChangePathParams,
	CampaignStatusChangeRequest,
	CampaignStatusChangeResponse,
} from '../types/CampaignStatusChange'

/**
 * PATCH /campaigns/:campaign/status
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignStatusController.php CampaignStatusController::change
 */
export async function campaignStatusChange(
	campaign: CampaignStatusChangePathParams['campaign'],
	data: CampaignStatusChangeRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignStatusChangeResponse>> {
	return axiosInstance.patch(`/campaigns/${campaign}/status`, data, config)
}
